/* eslint-disable import/prefer-default-export */
import Dexie from 'dexie';

export const db = new Dexie('SchoolDB');
db.version(1).stores({
  classes: '++id, &name, class_1_id, class_2_id',
  classrooms: '++id, &name, remark, status',
  sessions:
    '++id, subject_id, class_id, teacher_id, classroom_id, weekday, start_time, end_time',
  subjects: '++id, &name',
  teachers: '++id, &name, subject, email, tel, status',
});

db.on('populate', () => {
  db.subjects.add({
    name: 'إدارة',
  });
  db.classrooms.add({
    name: 'إدارة',
    status: 1,
  });
});
db.open();
